import { render, staticRenderFns } from "./SendRequestDialog.vue?vue&type=template&id=68711aa0"
import script from "./SendRequestDialog.vue?vue&type=script&lang=js"
export * from "./SendRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports